const congreso = [
  {
    name: "congreso-2022",
    id: [463, 10218],
    slug: "festival-bienestar-para-estar-bien",
  },
];

export default congreso;
